module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('no-auth-layout', [_c('div', {
    staticClass: "check-inbox-page center-align"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/send_email.png"),
      "alt": "email wysłany"
    }
  }), _vm._v(" "), _c('h2', {
    staticClass: "card-title"
  }, [_vm._v("Sprawdź skrzynkę")]), _vm._v(" "), _c('p', {
    staticClass: "card-subtitle"
  }, [_vm._v("\n      Kliknij w link aktywacyjny,"), _c('br'), _vm._v("\n       aby w pełni korzystać ze swojego konta.\n    ")]), _vm._v(" "), _c('router-link', {
    attrs: {
      "to": {
        name: 'login'
      }
    }
  }, [_c('button', {
    staticClass: "btn-large z-depth-0"
  }, [_c('i', {
    staticClass: "mfind-icon-back left"
  }), _vm._v("\n        Wróć do logowania\n      ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('div', {
    staticClass: "card-footer"
  }, [_vm._v("\n      Jeśli nadal potrzebujesz pomocy,"), _c('br'), _vm._v("\n      wyślij email na "), _c('a', {
    attrs: {
      "href": "mailto:partnerzy@punkta.pl"
    }
  }, [_vm._v(" partnerzy@punkta.pl ")])])], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5a5f8171","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/pages/checkInbox.vue
// module id = 382
// module chunks = 0